<template>
  <div v-if="videoUrl">
    <iframe
      :src="`https://www.youtube.com/embed/${videoUrl}`"
      frameborder="0"
      allow="encrypted-media; picture-in-picture"
      allowfullscreen
      class="youtube-iframe"
      :style="iframeStyle"
    ></iframe>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'YouTubePlayer',
  props: {
    videoLink: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '100%', // default width if not passed
    },
    height: {
      type: String,
      default: 'auto', // default height if not passed
    },
    maxWidth: {
      type: String,
      default: 'auto', // default max-width if not passed
    },
  },
  computed: {
    videoUrl() {
      const match = this.videoLink?.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?]+)/);
      return match ? match[1] : this.videoLink || '';
    },
    iframeStyle() {
      return {
        width: this.width,
        height: this.height,
        maxWidth: this.maxWidth,
      };
    },
  },
});
</script>

<style scoped>
.youtube-iframe {
  width: 100%;
  /* max-width: 790px;
  height: 450px; */
  aspect-ratio: 1.77777;
}
@media (max-width: 1200px){
  .youtube-iframe{
    height: auto;
    aspect-ratio: 1.77777;
    width: 100%;
  }
}
@media (max-width: 768px) {
  .youtube-iframe {
    max-height: 500px;
  }
}
</style>